// Constants

// Constants
const SubAPIPostCode_url = "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com";
const datesRangeLimit = 2;

// Extend dayjs with plugins
dayjs.extend(window.dayjs_plugin_utc);
dayjs.extend(window.dayjs_plugin_timezone);
dayjs.extend(window.dayjs_plugin_isSameOrBefore);

const currentDate = dayjs().tz("Australia/Sydney");
console.log({currentDate});

const showLoader = () => document.querySelector('#loaderContainerMin')?.classList.add('active');
const hideLoader = () => {
  setTimeout(() => {
    document.querySelector('#loaderContainerMin')?.classList.remove('active');
  }, 1500);
};

// Event Handlers
$(document).ready(() => {
  $(".sticky-postal-sidebar").on("click", () => {
    $('.cart-count').trigger("click");
    $('.checkPostalBtnShipping').trigger("click");
  });

  $(document).on("click", ".delOpt", async function () {

    $(".loading").removeClass("d-none");
    const allDataAttributes = $(this).data();
    const suburb = allDataAttributes.suburb;
    const postCodeVal = allDataAttributes.postcode;
    const deliveryDate = allDataAttributes.deliveryDate;
    const { item_count, original_total_price, attributes } = localCart.getCartData();
    let orderType;
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
      orderType = "OneTimePurchase";
    } else {
      orderType = attributes?.orderType?.type || "WeeklySubscription";
    }
    let summaryBtn = qs("#toPlan");
    const deliveryInfo = {
      deliveryDate,
      suburb,
      postcode: postCodeVal
    };

    showLoader();

    $.ajax({
      url: `${SubAPIPostCode_url}/packing-dates/${suburb}/${postCodeVal}/${datesRangeLimit}/${deliveryDate}`,
      type: "GET",
      success: (response) => {
        const { data, status } = JSON.parse(response);
        if (status && data.length > 0) {
          allDataAttributes.packingDate = data;
        }
        allDataAttributes.timestamp = Date.now();
        updateFutureDeliveries(deliveryDate, orderType);
        localStorage.setItem("deliveryInfo", JSON.stringify(allDataAttributes));
        summaryBtn.disabled = true;

        if (allDataAttributes.packingDate) {

          renderDispatchDate();

        } else {

          $(".dispatchDate").remove();

        }

        $(".loading").addClass("d-none");
        hideLoader();
      },
      error: (xhr, textStatus, errorThrown) => {
        hideLoader();
        console.error({ errorThrown, xhr, textStatus });
      },
      complete: function() {
        hideLoader();
      }
    });

    $('.postCodeForm').animate({
      scrollTop: $(".windowDate").offset().top
    }, 1000);

    $(".windowCheckout").empty();
    $(this).addClass("active-date").siblings().removeClass("active-date");
    console.log("click delOpt");
  });

  $(document).on("click", ".timeOpt", async function () {
    const allDataAttributes = $(this).data();
    let deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo")) || {};
    deliveryInfo.deliveryStart = allDataAttributes.deliveryStart;
    deliveryInfo.deliveryEnd = allDataAttributes.deliveryEnd;
    deliveryInfo.timestamp = Date.now();
    localStorage.setItem("deliveryInfo", JSON.stringify(deliveryInfo));
    setCookie('expecting-delivery', deliveryInfo.deliveryDate, 7);
    //console.log({deliveryInfo});

    const { item_count, original_total_price, attributes } = localCart.getCartData();
    const cartAmountInDollars = original_total_price / 100;
    let orderType;
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
      orderType = "OneTimePurchase";
    } else {
      orderType = attributes?.orderType?.type || "WeeklySubscription";
    }
    const deliveryDate = getCookie("expecting-delivery");
    const isDeliveryDateSet = deliveryDate !== null;
    updateFutureDeliveries(deliveryInfo.deliveryDate, orderType);
    // Define the minimum cart amount based on order type
    let minCartAmount = 0;
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
      minCartAmount = orderType === "OneTimePurchase" ? MIN_NDIS_OTP_CART_AMOUNT : MIN_NDIS_SUBS_CART_AMOUNT;
    } else {
      minCartAmount = orderType === "OneTimePurchase" ? MIN_OTP_CART_AMOUNT : MIN_SUBS_CART_AMOUNT;
    }

    const isDeliveryInfoEmpty = !deliveryInfo || Object.keys(deliveryInfo).length === 0;

    // Define common classes for ease of modification
    const addOrangeClasses = ["bg-orange", "border-orange"];
    const removeOrangeClasses = ["checkPostalBtn2", "bg-orange", "border-orange"];
    let summaryBtn = qs("#toPlan");
    if (cartAmountInDollars < minCartAmount) {
      primaryButton.removeAttribute("onclick");
      primaryButton.classList.remove(...removeOrangeClasses);
      primaryButton.innerHTML = `Add $${(minCartAmount - cartAmountInDollars).toFixed(2)} more to your cart`;      
        
      if(isDeliveryInfoEmpty){
        summaryBtn.classList.add('hidden');
        summaryBtn.disabled = true;
      }else{
        summaryBtn.classList.remove('hidden');
        summaryBtn.disabled = false;
      }

    } else {
      if (isDeliveryDateSet) {
        primaryButton.setAttribute("onclick", "localCart.continueToShipping('mini-cart')");
        primaryButton.classList.add(...addOrangeClasses);
        primaryButton.classList.remove("checkPostalBtn2");
        primaryButton.innerHTML = 'Checkout Now';
        
        if(isDeliveryInfoEmpty){
          summaryBtn.classList.add('hidden');
          summaryBtn.disabled = true;
        }else{
          summaryBtn.classList.remove('hidden');
          summaryBtn.disabled = false;
        }

      } else {
        primaryButton.removeAttribute("onclick");
        primaryButton.classList.add("checkPostalBtn2");
        primaryButton.classList.remove(...addOrangeClasses);
        primaryButton.innerHTML = 'Select Delivery Date and Checkout';
        summaryBtn.disabled = true;
        summaryBtn.classList.add('hidden');
      }
    }
    $(this).addClass("active-time").siblings().removeClass("active-time");

    console.log("click timeOpt");
    $('.postCodeForm').animate({
      scrollTop: $(".windowTime").offset().top
    }, 1000);
  });

});


function renderDispatchDate() {
  const deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
  const packingDate = deliveryInfo?.packingDate;

  if (!packingDate) return;

  // Handle both array and single date string
  const dateToFormat = Array.isArray(packingDate) ? packingDate[0] : packingDate;
  const formatted = dayjs(dateToFormat).format("ddd DD MMM");

  const dispatchHtml = `
    <div class="dispatchDate mt-2 mb-2">
      <label>Dispatch Date: <span>${formatted}</span></label>
    </div>
  `;

  // ✅ If .windowTime exists → replace
  if ($(".dispatchDate").length) {
    $(".dispatchDate").replaceWith(dispatchHtml);
  } else {
    // fallback → append
    $(".windowTime").after(dispatchHtml);
  }

  // ✅ Mini cart update
  if ($("#dispatchDateMini").length) {
    $("#dispatchDateMini").text(formatted);
  }
}

// Functions
const updateTimeSlots = (data, selectedDate) => {
  const timeSlotsContainer = $('<div class="windowTime"><label>Time Slots:</label><div class="nextTime"></div></div>');
  const dateInfoArray = data[selectedDate];

  const morningSlot = dateInfoArray.find(slot => slot.time_start === "00:00:00" && slot.time_end === "07:00:00");
  const daySlot = dateInfoArray.find(slot => slot.time_start === "08:00:00" && slot.time_end === "18:00:00");

  if (morningSlot) {
    const morningTimeStart = formatTime(morningSlot.time_start);
    const morningTimeEnd = formatTime(morningSlot.time_end);
    const morningHtmlInsert = $('<div class="timeOpt"></div>')
      .text(`${morningTimeStart} - ${morningTimeEnd}`)
      .data("deliveryStart", morningSlot.time_start)
      .data("deliveryEnd", morningSlot.time_end);
    timeSlotsContainer.find('.nextTime').append(morningHtmlInsert);
  }

  if (daySlot) {
    const dayTimeStart = formatTime(daySlot.time_start);
    const dayTimeEnd = formatTime(daySlot.time_end);
    const dayHtmlInsert = $('<div class="timeOpt"></div>')
      .text(`${dayTimeStart} - ${dayTimeEnd}`)
      .data("deliveryStart", daySlot.time_start)
      .data("deliveryEnd", daySlot.time_end);
    timeSlotsContainer.find('.nextTime').append(dayHtmlInsert);
  }
  //$(".windowDeliery").empty();
  $(".windowTime").replaceWith(timeSlotsContainer);
};

const formatTime = (time) => {
  if (time === "00:00:00") return "Midnight";
  const [hours, minutes] = time.split(':');
  const intHours = parseInt(hours, 10);
  const period = intHours < 12 ? 'AM' : 'PM';
  const formattedHours = intHours % 12 || 12; // Convert 0 to 12 for midnight
  return `${formattedHours}:${minutes} ${period}`;
};

const updateFutureDeliveries = (selectedDate, subscriptionType) => {
  // subscriptionType: "WeeklySubscription" or "OneTimePurchase" or others.
  // For delivery cycles UI we only care about Weekly vs Fortnightly.
  const isWeekly = subscriptionType === "WeeklySubscription";
  const typeLabel = isWeekly ? "Weekly" : "Fortnightly";

  const startDate = dayjs(selectedDate);
  const intervalDays = isWeekly ? 7 : 14;

  // Build next 4 cycles
  const cycles = [];
  for (let i = 0; i <= 3; i++) {
    cycles.push(startDate.add(intervalDays * i, "day"));
  }

  // If no dates, hide block
  if (!cycles.length) {
    $(".windowDeliery").addClass("d-none");
    return;
  }

  const next = cycles[0];
  const moreCount = Math.max(0, cycles.length - 1);

  // Example: Friday
  const weekday = next.format("dddd");

  // Example: Fri 28 Feb
  const nextLabel = next.format("ddd DD MMM");

  // Summary text:
  // Weekly · Every Friday | Next: Fri 28 Feb (+2 more)
  const summaryText =
    typeLabel +
    " · Every " +
    weekday +
    " | Next: " +
    nextLabel +
    (moreCount > 0 ? " (+" + moreCount + " more)" : "");

  const summaryTextTop =
    typeLabel +
    " · Every " +
    weekday;


  // Container (NO "Future Delivery Cycles" label)
  const $container = $(`
    <div class="windowDeliery mt-2 d-none">
      <div class="nextDeliveries">
        <div class="deliverySummary d-flex align-items-center justify-content-between text-start" style="cursor:pointer;">
          <span class="summaryText"></span>
          <span class="summaryToggle"><i class="fa-solid fa-chevron-down"></i></span>
        </div>
        <div class="deliveryList d-none mt-1"></div>
      </div>
    </div>
  `);

  $container.find(".summaryText").text(summaryText);

  // Full list (hidden by default)
  const listHtml = cycles.slice(1)
    .map(d => `<div class="cycleItem py-1">${d.format("ddd DD MMM")}</div>`)
    .join("");
  $container.find(".deliveryList").html(listHtml);

  // Toggle expand/collapse

  $container.find(".deliverySummary").on("click", function () {
    const $list = $container.find(".deliveryList");
    const $icon = $container.find(".summaryToggle i");
    $list.toggleClass("d-none");
    $list.toggleClass("is-open");
    $icon.toggleClass("fa-chevron-down fa-chevron-up");
  });

  // Replace existing block and show
  const $old = $(".windowDeliery");
  if ($old.length) {
    $old.replaceWith($container);
  } else {
    // fallback: append near delivery/time sections if container doesn't exist
    $(".windowTime").after($container);
  }
  $container.removeClass("d-none");

  // Keep your existing "nextDeliveriesNew" compact text if used elsewhere
  let compact = "";
  cycles.forEach((d, i) => {
    compact += `<span>${i > 0 ? ", " : ""}${d.format("ddd DD MMM")}</span>`;
  });
  $(".nextDeliveriesNew").html(summaryTextTop);
};


const listSuburbsBasedOnPostCode = (postCodeVal, suburb, expectedDate = currentDate) => {
  $(".text-failer").addClass("d-none");
  $(".loading").removeClass("d-none");

  const windowSuburbCont = $(".windowSuburbCont");
  windowSuburbCont.empty();
  $(".windowDate, .windowTime").addClass("d-none");
  $(".windowCheckout").empty();
  const nextDel = $(".nextDel");
  nextDel.empty();

  if (!postCodeVal || postCodeVal.length < 4) {
    $("#postcode2").addClass("error");
    $(".loading").addClass("d-none");
    return;
  }

  // ✅ 4-hour expiration check
  const fourHours = 4 * 60 * 60 * 1000;
  let loca_del = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
  let window_state_NEW = JSON.parse(localStorage.getItem("window_state") || "{}");
  if (loca_del.timestamp && (Date.now() - loca_del.timestamp > fourHours)) {
    console.log("🕒 Delivery selection expired (4 hours). Clearing.");
    localStorage.setItem("deliveryInfo", JSON.stringify({}));
    loca_del = {};
    if (typeof state !== 'undefined') {      
      state.date = "";
      state.time = "";
      state.state = "";
      state.suburb = "";
      state.postcode = "";
      window_state_NEW = state;
      localStorage.setItem("window_state", JSON.stringify(window_state_NEW));      
      document.querySelector(".windowTime")?.classList.add("hidden");
      document.querySelector(".dispatchDate")?.classList.add("hidden");
      document.querySelector("#toPlan")?.classList.add("hidden");
      document.querySelector(".windowDate")?.classList.add("hidden");
      document.querySelector('#address_12').value = '';
    }
  }
  const previouslySelectedDate = loca_del.deliveryDate || null;

  showLoader();

  $.ajax({
    url: `${SubAPIPostCode_url}/delivery-dates/${suburb}/${postCodeVal}/${datesRangeLimit}/${expectedDate.format("YYYY-MM-DD")}`,
    type: "GET",
    success: (response) => {
      const { data: dataValues = {}, status } = JSON.parse(response);

      let summaryBtn = qs("#toPlan");
      summaryBtn.disabled = true;

      hideLoader();

      if (status || Object.keys(dataValues).length > 0) {
        const deliveryDatesContainer = $('<div class="windowDate"><label>Delivery Dates:</label><div class="nextDel"></div></div>');
        let foundInNewResults = false;

        $.each(Object.keys(dataValues), (index, value) => {
          if (index >= 4) return false;
          const shipDate = new Date(value);
          const shipDateString = shipDate.toDateString().replace(shipDate.getFullYear(), "");
          const dateInfoArray = dataValues[value];

          const deliveryHtmlInsert = $('<div class="delOpt"></div>')
            .text(shipDateString)
            .data({
              "deliveryDate": value,
              "suburb": suburb,
              "postcode": postCodeVal
            })
            .on('click', () => updateTimeSlots(dataValues, value));

          // ✅ Preselect date ONLY (if it matches stored deliveryDate)
          if (previouslySelectedDate && previouslySelectedDate === value) {
            deliveryHtmlInsert.addClass("active-date");
            foundInNewResults = true;
            // Optionally pre-render time slots UI but no time is stored
            updateTimeSlots(dataValues, value);
          }
          deliveryDatesContainer.find('.nextDel').append(deliveryHtmlInsert);

        });

        if (previouslySelectedDate && !foundInNewResults) {
          console.log("Previously selected date is no longer viable. Clearing deliveryInfo.");
          localStorage.setItem("deliveryInfo", JSON.stringify({}));
          if (typeof state !== 'undefined') {
            state.date = "";
            state.time = "";
            localStorage.setItem("window_state", JSON.stringify(state));
          }
          $(".windowTime").addClass("d-none");
        }

        $(".resultMessage, .text-failer").addClass("d-none");
        $(".windowDate").replaceWith(deliveryDatesContainer).removeClass("d-none");

        renderDispatchDate();

      } else {
        $(".windowDate, .windowTime, .resultMessage, .dispatchDate").addClass("d-none");
        // F4: out-of-zone copy per Document #5 §1 (exact, ACL-compliant). The B6
        // /delivery-dates API is the source of truth for serviceability (serves
        // WA, excludes SA); this branch fires only when B6 returns no dates.
        $(".text-failer").removeClass("d-none").html(window.THR1VE_OUT_OF_ZONE_HTML || 'We are not currently servicing your area yet — follow our <a href="https://www.instagram.com/thr1ve/" target="_blank" rel="noopener">Instagram</a> for updates!');
      }
    },
    error: (xhr, textStatus, errorThrown) => {
      console.error({ errorThrown, xhr, textStatus });
      hideLoader();
      $(".text-failer").removeClass("d-none");
    },
    complete: () => {
      hideLoader();
      $(".loading").addClass("d-none");
    },
  });
};

// Rohit Tawar check address valid or not 
const addressConfirmPostCode = (postCodeVal, suburb, expectedDate = currentDate) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${SubAPIPostCode_url}/delivery-dates/${suburb}/${postCodeVal}/${datesRangeLimit}/${expectedDate.format("YYYY-MM-DD")}`,
      type: "GET",
      success: (response) => {
        try {
          const { data: dataValues = {}, status } = JSON.parse(response);
          if ((status == true) && (Object.keys(dataValues).length > 0)) {
            resolve("Success");
          } else {
            resolve("Notfound");
          }
        } catch (err) {
          reject("Error");
        }
      },
      error: () => {
        reject("Error");
      }
    });
  });
};